<template>
  <v-dialog :value="dialog" max-width="550" persistent>
    <v-card v-if="payslip">
      <v-form v-on:submit.prevent="confirm">
        <v-card-title>
          <span class="headline">Anular recibo</span>
        </v-card-title>

        <v-card-text>
          <p class="mb-5">
            El recibo <b>{{ payslip.file_name }}</b><span v-if="payslip.legajo"> de <b>{{ legajoLabel(payslip.legajo) }}</b></span>
            queda anulado en el historial, no se borra.
          </p>

          <v-textarea v-model="reason" label="Motivo*" name="reason" data-vv-as="motivo" v-validate="'required|max:1000'"
            rows="3"></v-textarea>
          <span class="red--text">{{ errors.first("reason") }}</span>

          <v-file-input v-model="file" accept=".pdf" label="Recibo de reemplazo (opcional)" prepend-icon="mdi-file-pdf-box"
            class="mt-4" show-size></v-file-input>
          <v-label>Se carga con el mismo legajo, período y tipo.</v-label>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text :disabled="loading" @click="close">Cancelar</v-btn>
          <v-btn color="success" text type="submit" :loading="loading">Anular</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { payslipService } from "@/libs/ws/payslipService";
import { legajoLabel } from "@/constants/payslips";

export default {
  props: {
    dialog: Boolean,
    payslip: Object,
  },
  data() {
    return {
      reason: "",
      file: null,
      loading: false,
      legajoLabel: legajoLabel,
    };
  },
  watch: {
    dialog(value) {
      if (!value) return;
      this.reason = "";
      this.file = null;
      this.$validator.reset();
    },
  },
  methods: {
    close() {
      this.$emit("updateDialog", false);
    },
    async confirm() {
      if (this.loading || !(await this.$validator.validate())) return;

      const formData = new FormData();
      formData.append("id", this.payslip.id);
      formData.append("reason", this.reason);
      if (this.file) formData.append("file", this.file);

      this.loading = true;
      payslipService
        .void_payslip(formData)
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.close();
            this.$emit("saved");
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error("Ocurrió un error al anular el recibo.", "Error");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
